/**
 * @author        woody@zumper.com (Woody Anderson)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   utility wrapper around Api.geos, handles chomping, defaults
 */

import { chomp } from '../utils'
import * as Api from './index'

/**
 * You must pass at least one of either:
 *
 * 1. both `lat` and `lng`, or
 * 2. `url`
 *
 * @param {{
 *   lat: number | null,
 *   lng: number | null,
 *   url?: string | null,
 *   hoodsLimit?: number,
 *   citiesLimit?: number,
 * } | {
 *   lat?: number | null,
 *   lng?: number | null,
 *   url: string,
 *   hoodsLimit?: number,
 *   citiesLimit?: number,
 * }} param0
 */
export const locate = ({ lat, lng, url, hoodsLimit = 0, citiesLimit = 0 }) => {
  const params = {
    hoodsLimit,
    citiesLimit,
    univsLimit: 0,
    basesLimit: 0,
    zipsLimit: 0,
  }
  if (lat && lng) {
    params.p = `${chomp(lat, 3)},${chomp(lng, 3)}`
  }
  if (url) {
    params.url = url
  }
  return Api.geos.get(params)
}
